import { render, staticRenderFns } from "./solo_premium.vue?vue&type=template&id=2d24ef5d&scoped=true"
import script from "./solo_premium.vue?vue&type=script&lang=js"
export * from "./solo_premium.vue?vue&type=script&lang=js"
import style0 from "./solo_premium.vue?vue&type=style&index=0&id=2d24ef5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24ef5d",
  null
  
)

export default component.exports